/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loaderContainer[_ngcontent-%COMP%]{position:fixed;z-index:99999;background:rgba(0,0,0,.5);width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.loaderContainer[_ngcontent-%COMP%]   .messageContainer[_ngcontent-%COMP%]{padding:10px 15px;background:#fff;box-shadow:0 0 10px rgba(0,0,0,.25);border-radius:50px}"];
export { styles as styles };
